import { html } from 'lit-element';

import { SimpleLitElement } from '@elab/components';
import { dateToString } from '@elab/core/utils/DateUtils';
import { getValueByStorePath } from '@elab/core/utils/helpers';
import connect from '@elab/core/store/connect';

export class DateContent extends SimpleLitElement {
    static get properties() {
        return {
            name: { type: String },
            defaultValue: { type: String, attribute: 'default-value' },

            // Redux
            fieldValue: { type: String, attribute: false },
            formatter: { type: String },
        };
    }

    constructor() {
        super();
        this.name = '';
        this.formatter = '';
        this.defaultValue = '';
    }

    render() {
        return html`
            ${this.formatter
                ? dateToString(this.fieldValue, this.formatter)
                : dateToString(this.fieldValue)}
        `;
    }
}

const mapStateToProps = (state, ctx) => {
    return {
        fieldValue: getValueByStorePath(ctx.name, state) || ctx.defaultValue,
    };
};

export default () =>
    customElements.define('e2-date-content', connect(mapStateToProps)(DateContent));
